export const ru = {
    need_help: 'Нужна помощь?',
    contact_support_with_any_questions: 'Обращайтесь в поддержку с любыми вопросами по процессу оформления командировки',
    ask_question: 'Задать вопрос',
};
